import { USER_ROLES, type UserRole } from "@repo/ui/constants/userRoles";

type FirstPassengerKeys = Readonly<Record<string, string>>;

/**
 * Calculates the pet on-board price based on user type and passenger position.
 * STAFF: first passenger in the leg pays 1; others pay basePrice.
 * CUSTOMER: everyone pays basePrice.
 */
export function calculatePetOnBoardPrice(
  userType: UserRole,
  passengerKey: string,
  firstPassengerKeys: FirstPassengerKeys,
  direction: string,
  basePrice: number,
  isSSrKeyAvailable: boolean,
  isSoldOut?: boolean,
): number {
  if (!isSSrKeyAvailable) {
    return 0;
  }

  if (isSoldOut) {
    return 0;
  }

  const isStaffFirstPassenger =
    userType === USER_ROLES.Staff && passengerKey === firstPassengerKeys[direction];

  if (!isStaffFirstPassenger) {
    return basePrice;
  }

  return 1;
}
